import { render } from "./Inputi18nInline.vue?vue&type=template&id=63c5f6f0&scoped=true"
import script from "./Inputi18nInline.vue?vue&type=script&lang=js"
export * from "./Inputi18nInline.vue?vue&type=script&lang=js"

import "./Inputi18nInline.vue?vue&type=style&index=0&id=63c5f6f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c5f6f0"]])

export default __exports__